import { PlataformaStreaming } from '@/types/plataformaStreaming';
import * as S from './styles';
import { Skeleton } from '@/components/atoms/Skeleton';
import { CSSProperties, ReactNode, useCallback } from 'react';
import ScrollAreaColunaContainer from '@/components/molecules/ScrollAreaColunaContainer';
import BotaoEscolherPlataforma from '@/components/molecules/BotaoEscolherPlataforma';

export type ListagemPlataformasProps = {
  $loading: boolean;
  $plataformas: PlataformaStreaming[];
  $funcaoSelecionarPlataforma: (valor: string) => void;
  $plataformaSelecionada: string;
  style?: CSSProperties;
  $scrollContainerHeight?: string;
  $modal?: boolean;
};

export default function ListagemPlataformas(props: ListagemPlataformasProps) {
  const {
    $loading,
    $plataformas,
    $funcaoSelecionarPlataforma,
    $plataformaSelecionada,
    style = {},
    $scrollContainerHeight = '40vh',
    $modal = false,
  } = props;

  const ScrollContainerCondicional = useCallback(
    ({ children }: { children: ReactNode }) => {
      if ($modal) {
        return (
          <ScrollAreaColunaContainer
            style={{ height: $scrollContainerHeight }}
            orientacao="vertical"
          >
            {children}
          </ScrollAreaColunaContainer>
        );
      }

      return children;
    },
    [$modal, $scrollContainerHeight],
  );

  return (
    <ScrollContainerCondicional>
      <S.Container style={style}>
        {$loading
          ? Array.from({ length: 4 }).map((item, index) => (
              <Skeleton key={`${item}_${index}`} style={{ height: 64 }} />
            ))
          : null}
        {!$loading && $plataformas.length
          ? $plataformas.map((plataforma) => (
              <BotaoEscolherPlataforma
                key={plataforma.plataformaStreamingID}
                $onClick={() =>
                  $funcaoSelecionarPlataforma(plataforma.plataformaStreamingID)
                }
                $plataforma={plataforma}
                $plataformaSelecionada={$plataformaSelecionada}
              />
            ))
          : null}
      </S.Container>
    </ScrollContainerCondicional>
  );
}
